export default {
    namespaced: true,
    state: {
        quant: 1,
        mainPrice: null,
        annexation: 0,
        crossflag: false,
        fetchInfo: null
    },
    mutations: {
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        },
        setMainPrice (state,payload) {
            state.mainPrice = payload
        },
        setCrossFlag (state,payload) {
            state.crossflag = payload
        },
        setInfo (state,payload) {
            state.fetchInfo = payload
        }
    },
    getters: {

    },
    actions: {},
    modules: {

    }
}